import PropTypes from 'prop-types'
import React from 'react'
import { connect } from 'react-redux'
import { createDocumentGdrive } from '../actions/documents'
import { tagFunnel } from '../actions/tagmanager'
import DocumentUploadBtn from './DocumentUploadBtn'
import DocumentTextarea from './DocumentTextarea'
import ErrorMessage from './ErrorMessages'
import Button from '../components/base/Button'
import Icon from '../components/base/Icon'
import styles from './UploadOptions.css'
import css from '../util/css'
import { GDRIVE } from '../util/dataTestIds'

export function UploadOptions({ openCheckModal, initialized, headingText, subheadingText, theme }) {
  return (
    <div className={css.classNames(styles, 'paperUploadUi')}>
      <h1 className={css.classNames(styles, 'title')}>{headingText}</h1>
      <h2 className={styles.subText}>{subheadingText}</h2>
      <div className={styles.uploadOptions}>
        <DocumentTextarea initialized={initialized} />
        <div className="paper-entry text-center">
          <p className={css.classNames(styles, 'p')}>or, import your paper</p>
          {initialized && <ErrorMessage />}
          <div className={styles.uploadButtonsWrapper}>
            <DocumentUploadBtn />
            <Button
              theme={theme}
              inverted
              halfWidth
              disabled={!initialized}
              data-id="gDriveUpload"
              data-test-id={GDRIVE}
              onClick={e => openCheckModal(e)}
            >
              <Icon name="google-drive" size="16" />
              <span>It&apos;s on Google Drive &trade;</span>
            </Button>
          </div>
          <small className={css.classNames(styles, 'legal')}>
            The papers you upload will be added to our plagiarism database and will be used internally to improve
            plagiarism results.
          </small>
        </div>
      </div>
    </div>
  )
}

UploadOptions.propTypes = {
  openCheckModal: PropTypes.func.isRequired,
  initialized: PropTypes.bool.isRequired,
  theme: PropTypes.string.isRequired,
  headingText: PropTypes.string,
  subheadingText: PropTypes.string,
}

UploadOptions.defaultProps = {
  headingText: 'Try our smart proofreader',
  // eslint-disable-next-line max-len
  subheadingText: `Don't worry, your writing won't be searchable publicly or in any other database. No other plagiarism checkers will see your paper.`,
}

const mapStateToProps = state => ({
  initialized: state.app.initialized,
  theme: state.theme,
})

const mapDispatchToProps = dispatch => ({
  openCheckModal: e => {
    e.preventDefault()
    dispatch(createDocumentGdrive())
    dispatch(tagFunnel('upload paper', 'on google drive'))
  },
})

export default connect(mapStateToProps, mapDispatchToProps)(UploadOptions)
